import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { normalizeStageLogs } from "./ViewCandidatePopupModal";
import PipelineHistoryTimeline from "./PipelineHistoryTimeline";

const getCandidateName = candidate =>
  [candidate?.first_name, candidate?.middle_name, candidate?.last_name]
    .filter(Boolean)
    .join(" ") || "Candidate";

const getCandidateInitials = candidate =>
  getCandidateName(candidate)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part.charAt(0).toUpperCase())
    .join("");

const CandidateLogsTimelineModal = ({ isOpen, toggle, candidate }) => {
  const logs = normalizeStageLogs(candidate);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader
        toggle={toggle}
        style={{
          border: "none",
          background: "linear-gradient(135deg, #eef2ff, #f5f3ff)",
          borderRadius: "0.3rem 0.3rem 0 0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", paddingRight: 38 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #6366f1, #7c3aed)",
                color: "#fff",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 800,
                fontSize: 15,
                boxShadow: "0 8px 18px rgba(79, 70, 229, 0.28)",
                flex: "0 0 auto",
              }}
            >
              {getCandidateInitials(candidate)}
            </div>
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  color: "#64748b",
                  fontSize: 12,
                  fontWeight: 800,
                  marginBottom: 3,
                  whiteSpace: "nowrap",
                }}
              >
                Pipeline History
              </div>
              <div
                style={{
                  fontWeight: 800,
                  color: "#0f172a",
                  fontSize: 18,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={getCandidateName(candidate)}
              >
                {getCandidateName(candidate)}
              </div>
            </div>
          </div>
        </div>
      </ModalHeader>

      <ModalBody style={{ maxHeight: "58vh", overflowY: "auto", background: "#fbfbfe" }}>
        <PipelineHistoryTimeline items={logs} emptyMessage="No logs found." />
      </ModalBody>

      <ModalFooter className="border-0 justify-content-center">
        <Button
          onClick={toggle}
          style={{ background: "#4f46e5", border: "none", borderRadius: 10, padding: "0.45rem 1.35rem" }}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CandidateLogsTimelineModal;
